export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes`;
export const TIMEOUT_SEC = 5;
export const RES_PER_PAGE = 10;
export const KEY = '3b6098da-deaf-4601-adea-09c91489e944';
export const MODAL_CLOSE_SEC = 2.5;
